import { CKCompanyLogo, CKCompanyLogoProps } from 'clearkit';
import { FC } from 'react';

type CompanyLogoProps = CKCompanyLogoProps;

const CompanyLogo: FC<CompanyLogoProps> = ({
  className,
  cornerRadius = 100,
  ...rest
}) => (
  <CKCompanyLogo className={className} cornerRadius={cornerRadius} {...rest} />
);

export default CompanyLogo;
